import { render } from "./Vip.vue?vue&type=template&id=27f6cda0"
const script = {}

import "./Vip.vue?vue&type=style&index=0&id=27f6cda0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__